import TicketingAdministrativeAreasService from 'js/services/api/ticketing/administrative-areas.js'
import sha256 from 'crypto-js/sha256'

export default ({
  namespaced: true,
  state: {
    administrativeArea: null
  },
  mutations: {
    setAdministrativeArea(state, administrativeArea) {
      state.administrativeArea = administrativeArea
    }
  },
  getters: {
    hasAdministrativeArea(state) {
      return !_.isEmpty(state.administrativeArea)
    },
    administrativeArea(state) {
      return state?.administrativeArea || {}
    },
    administrativeAreaId(state) {
      return state?.administrativeArea?.id || null
    },
    administrativeAreaTimeZone(state) {
      return (state.administrativeArea || {}).time_zone
    },
    getOperatorIds(state) {
      return state?.operator_ids || []
    },
    getEnabledBusinessTypes (state) {
      return state?.administrativeArea?.config?.enabled_business_types || []
    }
  },
  actions: {
    async loadAdministrativeArea({commit, dispatch}, {administrativeAreaId}) {
      if (!administrativeAreaId) {
        return
      }
      const params = {
        template: 'with_parameters_with_counter'
      }

      const administrativeArea = await TicketingAdministrativeAreasService.show(
        administrativeAreaId, params
      )

      commit('setAdministrativeArea', administrativeArea)
      dispatch('user/getOperators', {}, {root: true})
    },

    async loadAdministrativeAreaFromMunicipality({getters, commit, dispatch, rootGetters}, options) {
      let municipality_id = null
      if(!_.isEmpty(options?.municipalityId)) {
        municipality_id = options.municipalityId
      } else if(rootGetters['appConfig/municipality_ids'].length === 1) {
        municipality_id = rootGetters['appConfig/municipality_ids'][0]
      } 
      
      const params = {
        municipality_id: municipality_id,
        template: 'with_parameters_with_counter',
        per: 1
      }

      const {data: administrativeAreas} = await TicketingAdministrativeAreasService.index(params)

      /** Check the config of any administrative areas recieved and check the local hash against the api hash */
      let validation_checks = administrativeAreas.map((item) => {
        const backend_hash = item.config_validation
        const local_hash = sha256(JSON.stringify(item.config)).toString()
        return backend_hash === local_hash
      })

      const administrativeArea = administrativeAreas[0]

      if(!validation_checks.includes(false) && administrativeArea) {
        commit('setAdministrativeArea', administrativeArea)
        // Misma secuencia que loadAdministrativeArea: con AA listo, recargar operadores
        dispatch('getOperators', null, {root: true})
      } else {
        commit('setAdministrativeArea', null)
        Vue.router.push({ name: 'error' });
        /** @todo report to backend */
      }
    }
  }
})
